import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Table
} from 'antd'
import Feather from '@sysunite/react-feather'

export default RegistryForm = ({ data, formRef, formName, item, isEditing }) ->
  columns = [{
    title: 'Key'
    dataIndex: 'key'
  }, {
    title: 'Value'
    dataIndex: 'value'
  }]

  if isEditing
    <Form
      ref={formRef}
    >
      <Form.List name={formName}>
        {(fields, { add, remove }) ->
          <div>
            {
              fields.map((field, index) ->
                <Form.Item style={{ margin: 0 }} key={field.key}>
                  <Row gutter={8} type="flex">
                    <Col style={{ flex: 1 }}>
                      <Form.Item name={[field.name, 'key']}>
                        <Input data-testid="#{item}-key-input"/>
                      </Form.Item>
                    </Col>
                    <Col style={{ flex: 1 }}>
                      <Form.Item name={[field.name, 'value']}>
                        <Input data-testid="#{item}-label-input"/>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Button data-testid="remove-#{item}" danger type="link" onClick={-> remove(field.name)}><Feather type="x" /></Button>
                    </Col>
                  </Row>
                </Form.Item>
              )
            }
            <Form.Item>
              <Button data-testid="add-#{item}" onClick={-> add()} type="dashed" block>
                <Feather type="plus" /> Add { item }
              </Button>
            </Form.Item>
          </div>
        }
      </Form.List>
    </Form>
  else
    <Table
      size='small'
      showHeader={false}
      columns={columns}
      dataSource={_.map(data, (value, key) -> { key, value })}
    />
